import Dbm from "dbm";
import Website from "../../../index.js";

export default class Airplane extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        
        this.item.setValue("originalInertia", 0);
        this.item.setValue("groundOffset", 3);
    }

    createGraphics() {
        let currentSprite = Website.game.getSprite("enemies/airplane", "airplane");
        currentSprite.anchor.set(0.5, 0.5);
        

        this.item.pixiLayer.addChild(currentSprite);
    }

    setup(aFront = true) {

        let collisionFilter;
        if(aFront) {
            collisionFilter = Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.TABLE_ITEM_FRONT, Website.game.PhysicsGroups.TABLE_ITEM_FRONT_INTERACTIONS);
        }
        else {
            collisionFilter = Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.TABLE_ITEM_BACK, Website.game.PhysicsGroups.TABLE_ITEM_BACK_INTERACTIONS);
        }

        let mainBody = Matter.Bodies.fromVertices(0, 0, [
            { x: -14, y: 0 },
            { x: 16, y: -7 },
            { x: 18, y: 7 }
            ], {
            label: "paper",
            restitution: 0,
            collisionFilter: collisionFilter
        });

        let body = Matter.Body.create({
            parts: [mainBody],
            label: "paper-compound",
            restitution: 0,
            mass: 0.01,
            collisionFilter: collisionFilter
        });

        this.item.originalInertia = body.inertia;

        this.item.setValue("physicsBody", body);
    }

    update(aTime, aDelta) {

        let basePosition = Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION+10-this.item.groundOffset;

        this.item.pixiLayer.x = this.item.physicsBody.position.x;
        this.item.pixiLayer.y = this.item.physicsBody.position.y+basePosition;

        this.item.pixiLayer.rotation = this.item.physicsBody.angle;
    }
}